import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "components/styles/ArticleStyle.scss";
import { withTranslation } from "react-i18next";
import { IMAGE_DNS } from "utils/config/Config";
import { useInView } from "react-intersection-observer";
import { useRecoilValue } from "recoil";
import { isDeleteLoadingState, isProfilePageState } from "recoil/contentsAtom";
import NotContent from "components/community/pageRight/PostContent/NotContent";
import Social from "components/community/pageRight/Social/Social";
import WrapLoading from "components/common/loading/WrapLoading";
import { IPostContent, useInfiniteScrollQuery } from "api/postListApi";
import IsMyArticle from "components/community/common/isMyarticle/IsMyArticle";
import ContentsTags from "components/community/common/ContentsTags";
import PostFeedLoading from "components/common/loading/PostFeedLoading";
import ScrollLoading from "components/community/pageRight/PostContent/ScrollLoading";
import { PhotoAlbum } from "react-photo-album";
import { userInfoState } from "recoil/userInfoAtom";
import LastComment from "./LastComment";
import WriteLastComment from "./WriteLastComment";

function PostFeedContent() {
  const { service_code, title } = useParams();
  const sectionTItle = title === undefined ? "all" : title;
  const isDeleteLoading = useRecoilValue(isDeleteLoadingState);

  const isProfilePage = useRecoilValue(isProfilePageState);
  const [postNum, setPostNum] = useState<number>(0);
  const userInfo = useRecoilValue(userInfoState);
  const [isLoading, setIsLoading] = useState(false);

  const { getBoard, getNextPage, getBoardIsSuccess, getNextPageIsPossible } =
    useInfiniteScrollQuery({ service_code, sectionTItle });

  const [ref, isView] = useInView();

  useEffect(() => {
    if (isView && getNextPageIsPossible) {
      getNextPage();
    }
  }, [isView, getBoard]);

  useEffect(() => {
    if (title === undefined) {
      return;
    } else {
      window.scrollTo(0, 0);
    }
  }, [title]);

  const min = 128;
  const max = 640;
  const randomHeight = Math.floor(Math.random() * (max - min + 1)) + min;

  const breakpoints = [1080, 640, 384, 256, 128, 96, 64, 48];

  const photos = (imgs: any) => {
    const data = imgs.map((photo: string) => ({
      src: photo,
      width: 1080,
      height: 800,
      srcSet: breakpoints.map((breakpoint) => {
        const height = randomHeight;
        return {
          src: photo,
          width: breakpoint,
          height
        };
      })
    }));

    return data;
  };

  return isDeleteLoading ? (
    <WrapLoading />
  ) : (
    <article className="articlesWrap">
      {getBoardIsSuccess ? (
        getBoard?.pages[0].result === 1 ? (
          getBoard?.pages.map((pageData) =>
            pageData.boardpage.map((i: IPostContent) => (
              <div
                className="article clearfix"
                key={i.idx}
                onClick={() => setPostNum(i.idx)}
              >
                {/* 게시자 info */}
                <div className="info">
                  <img
                    className="user-pic"
                    src={
                      i.admin_flag === 0
                        ? i.profile_image_url_from !== "" &&
                          i.profile_image_url_from !== null
                          ? i.profile_image_url_from
                          : IMAGE_DNS +
                            "/Valofe_file/web/vfun/images/common/img-user-default-min.png"
                        : i.admin_icon
                    }
                    alt="user icon"
                  />
                  <div>
                    <IsMyArticle
                      idx={i.idx}
                      isWriter={
                        isProfilePage
                          ? i.user_Serial_from === userInfo.userSerial
                          : i.user_id === userInfo.Userid
                      }
                      nickname={{
                        to: isProfilePage
                          ? i.user_nickname_to
                          : i.user_nickname,
                        from: isProfilePage
                          ? i.user_nickname_from
                          : i.user_nickname
                      }}
                      serialNum={
                        isProfilePage
                          ? { to: i.user_Serial_to, from: i.user_Serial_from }
                          : {
                              to: userInfo.userSerial,
                              from: userInfo.userSerial
                            }
                      }
                      profilekey={i.profile_key}
                    />

                    <div className="date">{i.created_at}</div>
                  </div>
                </div>

                {/* 컨텐츠 제목, 내용 */}
                <div className="cont clearfix">
                  <ContentsTags
                    data={i.title}
                    className="title"
                    admin={i.admin_flag}
                  />
                  <ContentsTags
                    data={i.content}
                    className="text"
                    admin={i.admin_flag}
                  />
                  {/* 이미지 */}
                  {i.images !== null ? (
                    <div className={`txt`}>
                      <PhotoAlbum photos={photos(i.images)} layout="rows" />
                    </div>
                  ) : null}
                </div>
                {/* 좋아요, 댓글 */}
                <Social
                  likeCount={i.like_count}
                  idx={i.idx}
                  userLike={i.user_like_status}
                  commentCount={i.comment_count}
                  categoryTitle={sectionTItle}
                />

                <WriteLastComment
                  idx={i.idx}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  postNum={postNum}
                />

                {i.comment_count !== 0 ? (
                  <LastComment
                    service_code={service_code || ""}
                    sectionTItle={sectionTItle}
                    idx={i.idx}
                    isSuccess={isLoading}
                  />
                ) : null}
              </div>
            ))
          )
        ) : (
          <NotContent />
        )
      ) : (
        <PostFeedLoading />
      )}
      <ScrollLoading
        loadingConditions={
          getNextPageIsPossible === true && getBoard?.pages[0].result === 1
        }
        viewRef={ref}
      />
    </article>
  );
}

export default withTranslation()(PostFeedContent);
